module.exports = __webpack_public_path__ + "img/rakdanit_balet_no.d12c719b.png";